<template>
  <div class="d-flex flex-column  align-items-center mt-5">
    <h4>Fill in receipt information</h4>
    <div class="text-left d-flex flex-column">
      Name
      <input type="text" class="" @keyup="updateName($event.target.value)" placeholder="" :value="name" :disabled="!editable">
    </div>
    <div class="text-left d-flex flex-column mt-2">
      Company name (optional)
      <input type="text" class="" @keyup="updateCompanyName($event.target.value)" placeholder="" :value="company" :disabled="!editable">
    </div>
    <div class="text-left d-flex flex-column mt-2">
      Address
      <textarea @keyup="updateAddress($event.target.value)" :value="address" :disabled="!editable"></textarea>
    </div>
    <div class="text-left d-flex flex-column mt-2">
      Telephone
      <input type="text" class="" @keyup="updateTelephone($event.target.value)" placeholder="" :value="tel" :disabled="!editable">
    </div>
    <div class="detail text-danger mt-2" v-if="!editable">
      * You can't edit your information.
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    email: String,
    editable: Boolean
  },
  computed: {
    ...mapGetters([
      'name',
      'tel',
      'address',
      'company'
    ])
  },
  methods: {
    updateName(value) {
      this.$store.dispatch('updateName', value)
    },
    updateCompanyName(value) {
      this.$store.dispatch('updateCompany', value)
    },
    updateAddress(value) {
      this.$store.dispatch('updateAddress', value)
    },
    updateTelephone(value) {
      this.$store.dispatch('updateTel', value)
    },
  }
}
</script>

<style lang="scss" scoped>
input {
  width: 300px;
  border: 3px solid #C9D6FF;
  border-radius: 4px;
  font-size: 1.5rem;
  padding: 0 10px;
}
textarea {
  width: 300px;
  height: 150px;
  border: 3px solid #C9D6FF;
  border-radius: 4px;
  font-size: 1.5rem;
  padding: 0 10px;
}
</style>

